<template>
  <form action="" method="post">
    <h4 class="mbs">Neuigkeiten und Ankündigungs-E-Mails</h4>
    <span>{{ email }}</span>
    <div class="row mtm">
      <div class="column small-12">
        <label>
          <input
            v-model="productOfferAndPromotion"
            type="checkbox"
            name="offersAndPromotions"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black"
              >Produktangebote und Aktionen</strong
            >
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          Senden Sie mir jeden Monat fantastische, individuelle Angebote von DesignCrowd!
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newsletter"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Newsletter</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newsletterBlurb }}
        </p>
      </div>
    </div>
    <hr />
    <h4 class="mbm">Projektspezifische E-Mails</h4>
    <div class="row">
      <div class="column small-12">
        <label>
          <input
            v-model="generalProjectAlert"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">
              Allgemeine Projektwarnungen/Benachrichtigungen
            </strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.generalProjectAlertBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newDesignNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Benachrichtigung über neues Design</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newDesignNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="dailySummary"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">E-Mail mit täglicher Zusammenfassung</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.dailySummaryBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="inviteNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Benachrichtigung einladen</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.inviteNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column text-center">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mvm" />
        <button class="button mbn" @click="onSubmitUpdateSubscriptionsForm">
          Einstellungen aktualisieren
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: undefined,
    },
    productOfferAndPromotionEnabled: {
      type: Boolean,
      default: false,
    },
    newsletterEnabled: {
      type: Boolean,
      default: false,
    },
    generalProjectAlertEnabled: {
      type: Boolean,
      default: false,
    },
    newDesignNotificationEnabled: {
      type: Boolean,
      default: false,
    },
    dailySummaryEnabled: {
      type: Boolean,
      default: false,
    },
    inviteNotificationEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productOfferAndPromotion: this.productOfferAndPromotionEnabled,
      newsletter: this.newsletterEnabled,
      generalProjectAlert: this.generalProjectAlertEnabled,
      newDesignNotification: this.newDesignNotificationEnabled,
      dailySummary: this.dailySummaryEnabled,
      inviteNotification: this.inviteNotificationEnabled,
      unPrettierNuggets: {
        newsletterBlurb: `Senden Sie mir den von Hand kuratierten monatlichen (oder so ungefähr) Newsletter, vollgestopft mit Technik-, Geschäfts- und Designartikeln, Produkt-Updates, Tutorials, Profilen und Community-News`,
        inviteNotificationBlurb: `Senden Sie mir eine Benachrichtigung, wenn Designer Einladungen annehmen / ablehnen`,
        generalProjectAlertBlurb: `Senden Sie mir E-Mails zu meinen Projekten und Wettbewerben (z. B. Zahlungen und Projektstatus-E-Mails)`,
        newDesignNotificationBlurb: `Senden Sie mir jedes Mal eine Benachrichtigung, wenn ein neues Design für mein Projekt eingereicht wird`,
        dailySummaryBlurb: `Senden Sie mir eine tägliche Zusammenfassung neuer Designs und Aktivitäten im Zusammenhang mit meinen Live-Projekten`,
      }
    };
  },
  methods: {
    onSubmitUpdateSubscriptionsForm(e) {
      e.preventDefault();
      this.$emit('update-subscription', {
        productOfferAndPromotionEnabled: this.productOfferAndPromotion,
        newsletterEnabled: this.newsletter,
        generalProjectAlertEnabled: this.generalProjectAlert,
        newDesignNotificationEnabled: this.newDesignNotification,
        dailySummaryEnabled: this.dailySummary,
        inviteNotificationEnabled: this.inviteNotification,
      });
    },
  },
};
</script>
